import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RepaymentAlert.module.scss';
import { UnreadNotification } from '../../../../assets/icons';

interface RepaymentAlertProps {
  amount: number;
  dueDate: Date | string;
  currencySymbol?: string;
  onPayClick: () => void;
  onClose: () => void;
  className?: string;
}

const CloseIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M15 5L5 15M5 5L15 15" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

const RepaymentAlert: React.FC<RepaymentAlertProps> = ({
  amount,
  dueDate,
  currencySymbol = '₦',
  onPayClick,
  onClose,
  className = '',
}) => {
  const { t } = useTranslation();
  const formatAmount = (value: number) => {
    return new Intl.NumberFormat('en-US').format(value);
  };

  const formatDate = (date: Date | string) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div className={`${styles.alert} ${className}`}>
      <div className={styles.content}>
        {/* Icon */}
        <div className={styles.icon}>
          <UnreadNotification />
        </div>

        {/* Text Content */}
        <div className={styles.textContent}>
          <div className={styles.mainText}>
            <div className={styles.dotContainer}>
            <img className={styles.greenDot} src={'../../../images/green-dot.gif'} alt={t('home.web.greenDot')}/>
            <span className={styles.label}>{t('loanRepayment.nextRepayment')}</span>
            </div>
            <div className={styles.valueContainer}>
            <span className={styles.amount}>
              {currencySymbol}{formatAmount(amount)}
            </span>
            <span className={styles.date}>{formatDate(dueDate)}</span>
            </div>
          </div>
          
          <button 
            className={styles.payButton}
            onClick={onPayClick}
          >
            {t('home.web.clickHereToPayNow')}
          </button>
        </div>
      </div>

      {/* Close Button */}
      <button 
        className={styles.closeButton}
        onClick={onClose}
        aria-label={t('home.web.closeAlert')}
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export default RepaymentAlert;